import axios, { addInterceptors } from './interceptor-axios';
import config from '~/config';

class UploadDataService {
  constructor(token) {
    const headers = {};
    if (token) {
      headers.Authorization = token;
    }
    this.axios = axios.create({
      baseURL: config.apiDataURL,
      headers,
    });
    addInterceptors(this.axios);
  }

  getLinkUploadFiles = ({
    uploadType,
    files,
    file,
    userId,
    category,
    id,
    numberImages,
    numberPages,
  }) => {
    // let formData = new FormData();
    // files.map((file, index) => {
    //   formData.append(`file${index}`, file);
    // });
    const request = {
      method: 'POST',
      url: '/uploadURL',
      data: {
        uploadType,
        files,
        file,
        category,
        id,
        userId,
        numberImages,
        numberPages,
      },
    };
    return this.axios(request);
  };

  uploadFile = (fileObj, uploadUrl, cbUploadProgress, noCacheForJSON) => {
    const headers = {
      'Content-Type': fileObj.type,
      'Cache-Control':
        fileObj.type === 'application/json' && noCacheForJSON
          ? 'no-cache, max-age=0, must-revalidate'
          : 'public,max-age=2592000',
    };
    const options = {
      headers,
      onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        cbUploadProgress && cbUploadProgress(percentCompleted);
      },
      isForUploadS3: true,
    };
    return this.axios.put(uploadUrl, fileObj, options);
  };

  uploadFiles = async ({
    uploadUrls,
    files,
    cbUploadProgress,
    noCacheForJSON,
  }) => {
    console.log('uploadUrls', uploadUrls);
    console.log('files', files);

    let uploadPromises = files.map((f, index) => {
      // There is a case where originFileObj is not existed.
      if (!f.originFileObj) return Promise.resolve();

      return this.uploadFile(
        f.originFileObj,
        uploadUrls[index].uploadURL,
        cbUploadProgress,
        noCacheForJSON,
      );
    });

    await Promise.all(uploadPromises);
  };

  generatePDF = ({ title, workarea }) => {
    const request = {
      method: 'POST',
      url: '/pdf',
      data: {
        title,
        workarea,
      },
    };
    return this.axios(request);
  };
}

export default new UploadDataService();
